import { makeAutoObservable, computed } from 'mobx'
import Dashboard from '@mui/icons-material/Dashboard'
import EventNote from '@mui/icons-material/EventNote'
import AccessTime from '@mui/icons-material/AccessTime'
import Group from '@mui/icons-material/Group'
import AutoAwesomeMotion from '@mui/icons-material/AutoAwesomeMotion'
import Tune from '@mui/icons-material/Tune'
import Groups from '@mui/icons-material/Groups'

class LayoutStore {
  headerConfig = { title: '' }
  isMini = false
  rootStore = null

  constructor(rootStore) {
    makeAutoObservable(
      this,
      {
        rootStore: false,
        navItems: computed,
      },
      { autoBind: true },
    )
    this.rootStore = rootStore
  }

  // Метод для установки заголовка страницы
  setHeaderConfig(config) {
    // Сливаем с текущей конфигурацией, чтобы не терять другие возможные опции
    this.headerConfig = { ...this.headerConfig, ...config }
  }

  toggleMini() {
    this.isMini = !this.isMini
  }

  // Динамический список навигации в зависимости от типа организации
  get navItems() {
    const organizationStore = this.rootStore.organizationStore
    const baseItems = [
      {
        text: 'Дашборд',
        path: '/dashboard',
        icon: Dashboard,
        tourId: 'tour-step-dashboard',
      },
      {
        text: 'Журнал',
        path: '/bookings',
        icon: EventNote,
        tourId: 'tour-step-calendar',
      },
      {
        text: 'График работы',
        path: '/workinghours',
        icon: AccessTime,
        tourId: 'tour-step-working-hours',
      },
      {
        text: 'Клиенты',
        path: '/clients',
        icon: Group,
        tourId: 'tour-step-clients',
      },
      {
        text: 'Услуги',
        path: '/services',
        icon: AutoAwesomeMotion,
        tourId: 'tour-step-services',
      },
      {
        text: 'Профиль',
        path: '/account',
        icon: Tune,
        tourId: 'tour-step-account-settings',
      },
    ]

    // Показываем пункт "Команда" только для организаций в режиме 'team'
    if (organizationStore.isTeamMode) {
      baseItems.push({
        text: 'Команда',
        path: '/team',
        icon: Groups,
        tourId: 'tour-step-team',
      })
    }

    return baseItems
  }
}

export default LayoutStore
